import { redirect } from '@tanstack/react-router';

import { loadRuntimeConfig } from '@/lib/runtime-config.js';

/**
 * Route guard: if an admin has switched the Diagrams section off (runtime config
 * `features.diagrams === false`), redirect away from any `/diagrams*` route — the hidden nav entry
 * alone would still leave bookmarks and deep links working.
 *
 * The config is refetched on every navigation here rather than read from the boot copy, so a tab
 * left open for hours honours a switch flipped after it loaded. Fail-open, like its neighbours: a
 * failed refetch keeps the last value the loader had, and the loader's default is `true`, so a blip
 * fetching config leaves the section reachable rather than locking people out of their own boards.
 */
export async function ensureDiagramsEnabled(): Promise<void> {
  const config = await loadRuntimeConfig(true);
  if (!config.features.diagrams) {
    throw redirect({ to: '/' });
  }
}
